import { GoogleMapsLoader } from './GoogleMapsLoader'

class GoogleMaps {
  constructor (context, options) {
    this.context = context
    this.markers = []
    this.options = Object.assign({
      center: {
        lat: 0,
        lng: 0
      },
    }, options)
    
    this._initMapPromise = GoogleMaps.load().then((maps) => {
      this.map = new maps.Map(this.context, this.options);
      return maps
    })
  }
  
  addMarker (options) {    
    return this._initMapPromise
      .then((maps) => {
        options.map = this.map  
      
        if(options.icon instanceof GoogleMapsIconBuilder) {
          options.icon = options.icon.build(maps)
        }

        console.log(options)
        
        let marker = new maps.Marker(options)
        this.markers.push(marker)
        return marker
      })
  }
  
  static icon() {
    return new GoogleMapsIconBuilder()
  }
  
  static load() {
    if(GoogleMaps._isLoading) {
      return GoogleMaps._loadingPromise
    }
    
    if(GoogleMaps._provider) {
      return Promise.resolve(GoogleMaps._provider)
    }
    
    if(!window.GOOGLE_MAPS_API_KEY) {
      throw new Error('`window.GOOGLE_MAPS_API_KEY` is undefined! Please, set your Google API Key in `window.GOOGLE_MAPS_API_KEY` variable before loading all scripts')
    }
    
    GoogleMaps._isLoading = true
    
    GoogleMaps._loadingPromise = GoogleMapsLoader({
      key: window.GOOGLE_MAPS_API_KEY
    }).then((provider) => {
      GoogleMaps._provider = provider
      return Promise.resolve(GoogleMaps._provider)
    }).catch(() => {
      GoogleMaps._isLoading = false
    })
    
    return GoogleMaps._loadingPromise
  }
}

GoogleMaps._provider = null;

class GoogleMapsIconBuilder {
  constructor () {
    this.url = ''
    this.anchor = {}
    this.size = {}
  }
  
  build(maps) {
    return {
      url: this.url,
      origin: new maps.Point(0, 0),
      anchor: new maps.Point(this.anchor.x, this.anchor.y),
      size: new maps.Size(this.size.x, this.size.y)
    }
  }
  
  setUrl(url) {
    this.url = url
    
    return this
  }
  
  setAnchor(x, y) {
    this.anchor.x = x
    this.anchor.y = y
    
    return this
  }
  
  setSize(x, y) {
    this.size.x = x
    this.size.y = y
    
    return this
  }
}

export {
  GoogleMaps
}


// WEBPACK FOOTER //
// ./scripts/services/google-maps/GoogleMaps.js